import React from 'react';
import { RotateCcwIcon, ShieldCheckIcon, TruckIcon } from 'lucide-react';
const perks = [{
  icon: TruckIcon,
  text: 'Free delivery in NL & BE'
}, {
  icon: RotateCcwIcon,
  text: '30-day returns'
}, {
  icon: ShieldCheckIcon,
  text: 'Warranty handled by us'
}];
export function ProductPerks() {
  return <ul className="grid gap-2.5 border-t border-line pt-5 text-sm text-ink sm:grid-cols-3 sm:gap-4" data-id="element-348" data-mp="3npdic0xcwapg">
      {perks.map(({
      icon: Icon,
      text
    }) => <li key={text} className="flex items-center gap-2" data-id="element-349" data-mp="3irk7gul3ysiu">
          <Icon className="h-4 w-4 shrink-0 text-muted" aria-hidden="true" data-id="element-350" data-mp="3dxz931flrwj4" />
          <span className="text-xs font-medium" data-id="element-351" data-mp="38z63dv6k59ti">{text}</span>
        </li>)}
    </ul>;
}